import styled from "styled-components";
import Colors from "../../../../themes/Colors";
import { getDomain } from "../../../../services/utils";

const domain = getDomain(window.location.hostname);

const ScreensOutputSettingsHolder = styled.div`
  padding: 0 10px;

  @media only screen and (max-width: 767px) {
    padding: 0;
  }

  .groupFilter {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
  }

  .contentGroupFilter {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
  }

  /* Fila "Crear reglas" + "Optimizar": se envuelve si no entra */
  .rulesActionsRow {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }
  .createRulesWrapper {
    flex: 1 1 160px;
    min-width: 0;
  }
  .rulesActionsRow .searchAIPlannerButton {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .rulesActionsRow .searchAIPlannerButton .anticon {
    margin-left: 0;
  }

  /* Fila "Frecuencia [Asignar] Balancear" */
  .frequencyRow {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    flex-wrap: wrap;
  }
  .frequencyRow .btnAssignSpots {
    flex: 1 1 180px;
    min-width: 0;
  }
  .balanceBtn {
    background-color: ${Colors.primary};
    border-color: ${Colors.primary};
    color: ${Colors.white};
    height: 35px;
    flex: 0 0 auto;
  }
  .balanceBtn:hover,
  .balanceBtn:focus {
    background-color: ${Colors.primary};
    border-color: ${Colors.primary};
    color: ${Colors.white};
    opacity: 0.9;
  }

  .groupFilterButton {
    margin-bottom: 10px;
  }
  .ant-badge {
    width: 100%;
  }
  .ant-scroll-number.ant-badge-count {
    color: ${Colors.white};
    p {
      color: ${Colors.white} !important;
    }
  }
  .createRulesBtn {
    width: 100%;
    color: ${Colors.white};
    background: ${Colors.primary};
    margin-bottom: 20px;
  }

  .searchAIPlannerButton {
    color: ${domain === 'movImagen' ? Colors.primary : Colors.white};
    background: ${domain === 'movImagen' ? Colors.snow : Colors.blueDark};
    border-color: ${domain === 'movImagen' ? Colors.primary : Colors.blueDark};
    transition: background 0s ease, border-color 0s ease;
    margin-bottom: 20px;
  }
  .searchAIPlannerButton.dv360 {
    background: linear-gradient(to left, ${Colors.primary}, ${Colors.backgroundPrimary});
    border-color: ${Colors.primary};
  }
  .searchAIPlannerButton:hover {
      color: ${domain === 'movImagen' ? Colors.primary : Colors.white};
      background-color: ${domain === 'movImagen' ? Colors.snow : Colors.primary} !important;
      border-color: ${Colors.primary};
  }
`;

export default ScreensOutputSettingsHolder;